// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coverPage_coverPageContainer_M1kUE {
  height: 1110px;
  width: 100%;
  font-family: GothamRounded-Medium;
}

.coverPage_greyscale_bYUWU {
  background: white;
  color: black;
  --timetable-accent-color: #eaeaea;
}

.coverPage_date_YCLJ7 {
  padding-top: 3rem;
  font-size: 2rem;
  margin-left: 2rem;
}

.coverPage_margin_wBVKA {
  margin: 10px 2rem;
}

.coverPage_stopRow_ippxZ {
  font-family: GothamRounded-Book;
  font-size: 0.8rem;
  padding: 3px 0;
}

.coverPage_rowContainer_GY6QI {
  margin-top: 1rem;
  margin-left: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/coverPage/coverPage.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".coverPageContainer {\n  height: 1110px;\n  width: 100%;\n  font-family: GothamRounded-Medium;\n}\n\n.greyscale {\n  background: white;\n  color: black;\n  --timetable-accent-color: #eaeaea;\n}\n\n.date {\n  padding-top: 3rem;\n  font-size: 2rem;\n  margin-left: 2rem;\n}\n\n.margin {\n  margin: 10px 2rem;\n}\n\n.stopRow {\n  font-family: GothamRounded-Book;\n  font-size: 0.8rem;\n  padding: 3px 0;\n}\n\n.rowContainer {\n  margin-top: 1rem;\n  margin-left: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"coverPageContainer": `coverPage_coverPageContainer_M1kUE`,
	"greyscale": `coverPage_greyscale_bYUWU`,
	"date": `coverPage_date_YCLJ7`,
	"margin": `coverPage_margin_wBVKA`,
	"stopRow": `coverPage_stopRow_ippxZ`,
	"rowContainer": `coverPage_rowContainer_GY6QI`
};
module.exports = ___CSS_LOADER_EXPORT___;
